// Ce que plusieurs écrans partagent : les helpers (dates, natures, scénarios,
// droits), les composants communs, la page d'une route inconnue.
export default {
  /** Un pourcentage : l'espace avant « % » est française, l'anglais la retire. */
  pourcent: '{n} %',
  // `natureEnClair` (helper/lecture.helper.ts), indexé par la valeur sans accent.
  natures: {
    film: 'film',
    serie: 'série',
    article: 'article',
    produit: 'produit',
    evenement: 'événement',
    polemique: 'polémique',
    autre: 'autre',
    inconnu: 'nature inconnue',
    scrutin: 'scrutin',
    sortie: 'sortie',
    decision: 'décision',
    finale: 'finale',
  },
  scenarios: {
    phrase: '{bas} ~ {haut}',
  },
  // Les fenêtres du studio (`EFenetre`, `EEtapes`, `EPiedFenetre`, 15 octobre 2026).
  fenetre: {
    fermer: 'Fermer',
    annuler: 'Annuler',
    etapes: 'Les étapes',
    n: 'Étape {n} sur {total}',
    suivant: 'Suivant',
    precedent: 'Précédent',
  },
  // `EAvis` : l'avis d'un jumeau, un aperçu et la suite (13 octobre 2026).
  avis: {
    voirPlus: 'Voir plus',
    voirMoins: 'Voir moins',
    // Un texte sans guillemets (le « pourquoi » d'un sentiment, 15 octobre 2026).
    texte: '{texte}',
  },
  // `pourquoiPas` (composables/capabilities.composable.ts).
  droits: {
    role: 'Votre rôle ({role}) ne permet pas cette action - rôle {requis} requis.',
    roleInconnu: 'inconnu',
    module: 'Permission manquante : {modules}. Demandez-la à un administrateur.',
    ou: 'ou',
  },
  job: {
    enAttente: 'en attente',
    echec: 'échec sans message',
  },
  confiance: {
    faible: 'Confiance faible',
    moyenne: 'Confiance moyenne',
    forte: 'Confiance forte',
  },
  carteDuMonde: 'Carte du monde',
  preversion: {
    titre: 'Préversion',
    texte: "données simulées à titre d'illustration. Le backend de cet écran arrive dans une prochaine phase.",
  },
  introuvable: {
    titre: 'Cet écran n’existe pas',
    route: 'Aucune route ne correspond à {chemin}.',
    retour: 'Retour à l’accueil',
  },
  demographie: {
    titre: 'Qui a répondu',
    isos: '{n} ISO | {n} ISO | {n} ISOs',
    ageMedian: '· âge médian {age}',
    aucuneSortie: 'Aucune sortie enregistrée sur cette fenêtre.',
    agesExacts: 'Âges exacts',
    etendue: '{min} → {max} ans · {n} âge(s) distinct(s)',
    barreAge: '{age} ans - {isos}',
    mediane: 'médiane {age}',
    axes: {
      ages: 'Âge',
      genre: 'Genre',
      csp: 'CSP',
      segments: 'Segments',
    },
    documente: '{n} % documenté',
    nonDocumente: 'Non documenté par la synthèse du territoire - rien n’est deviné ici.',
    documentePour: 'Documenté pour {nombre} ISO sur {total}. | Documenté pour {nombre} ISO sur {total}. | Documenté pour {nombre} ISOs sur {total}.',
    tropPeu: 'Trop peu pour une répartition : elle afficherait un chiffre net tiré d’une poignée de réponses.',
    genres: {
      femme: 'Femmes',
      homme: 'Hommes',
      non_binaire: 'Non-binaire',
    },
    ecartTitre: 'Écart à la composition voulue',
    ecartSousTitre: '- les parts que la synthèse prescrit, face à qui est réellement sorti',
    ecartSansPart: 'La synthèse ne documente pas de part pour ce segment - il n’y a rien à comparer',
    ecartBruit: 'Sur {n} sortie(s), cet écart ne sort pas du bruit de tirage : on ne peut pas conclure.',
  },
  // Le bandeau de supervision (components/v4/V4BandeauSupervision.vue).
  supervision: {
    carteAria: 'Carte du monde : {veille} territoires en veille, {patrouille} en patrouille',
    paysPatrouille: '{nom} - en patrouille',
    paysVeille: '{nom} - en veille',
    paysHors: '{nom} - hors catalogue',
    continents: {
      ameriqueNord: 'Amérique du Nord',
      ameriqueSud: 'Amérique du Sud',
      europe: 'Europe',
      afrique: 'Afrique',
      asie: 'Asie',
      oceanie: 'Océanie',
    },
    titre: 'supervision · territoires',
    jourObserve: 'jour observé {jour}',
    session: 'session',
    recus: 'reçus',
    attendusVides: '{attendus} att. · {vides} vide',
    heureAudienceAide: 'Chaque territoire sort à l’heure de SON audience, pas à l’heure du serveur.',
    heureAudience: 'heure de l’audience',
    eclaireurs: 'éclaireurs',
    satures: 'saturés ≥ {seuil} %',
    surRecus: '/ {n} reçus',
    sujetsNeufs: 'sujets neufs',
    sur: 'sur {n}',
    divergences: 'divergences J+{n}',
    max: 'max J+{n}',
    sansClicMoyen: 'sans clic moy.',
    patrouille: 'patrouille',
    veille: 'veille',
    total: 'total',
    fondDeCarte: 'en veille · fond de carte',
    aucuneSortiePlanifiee: 'aucune sortie planifiée',
    horsCarte: '{n} hors carte',
    metropoles: '{n} métropoles',
    enPatrouille: 'en patrouille',
    enVeille: 'en veille',
    metrosAide: '{recues} reçues, {attendues} attendues sur {total}',
    terrain: 'terrain',
    sansClic: 'sans clic',
    syntheseEtudes: 'synthèse d’études',
    oui: 'oui',
    enCours: 'en cours',
    aucune: 'aucune',
    marquesRattachees: 'marques rattachées',
    sousTerritoires: 'sous-territoires observés',
    ouvrirFiche: 'ouvrir la fiche',
    horsCatalogueAucun: 'hors catalogue - aucun territoire',
    metropolesAria: 'Les métropoles en patrouille',
    national: 'national',
    horsCatalogue: 'hors catalogue',
    aTraiter: 'à traiter',
    triAide: 'Divergences par ancienneté, puis saturations par intensité, puis sujets neufs.',
    tri: 'tri : ancienneté',
    aucuneAlerte: 'aucune alerte sur le jour observé',
    attenteDigest: 'en attente du digest',
    aucuneAlerteMaisNeufs: 'aucune alerte - ci-dessous, ce qui bouge',
    jPlus: 'J+{n}',
    alerte: {
      divergence: 'terrain ≠ études · {sujet}',
      saturation: 'saturation · sorties sans clic',
      saturationDetail: '{n} % des sorties ne retiennent rien - réduire les éclaireurs ou revoir la synthèse.',
      neuf: 'sujet neuf · « {sujet} »',
      neufDetail: '{n} sujet(s) apparu(s) le {jour}.',
      dernierJour: 'dernier jour observé',
    },
    legende: {
      recu: 'reçu',
      sature: 'saturé ≥ {seuil}%',
      attendu: 'attendu',
      neuf: 'sujet neuf',
      vide: 'rien trouvé',
      jn: 'J+n',
      divergence: 'terrain≠études',
      veille: 'pas observé',
      fond: 'en veille',
    },
    verticales: 'verticales',
    domaines: '{n} domaines · sans coordonnées',
    barre: 'barre = part sans clic',
    tuileAttendue: '{nom} - session non rendue',
    tuile: '{nom} - {sorties} sorties, {sansClic}',
    pctSansClic: '{n} % sans clic',
    // Le catalogue en veille, compté par échelle (`geo_level`).
    echelles: {
      country: '{n} pays',
      region: '{n} région | {n} région | {n} régions',
      continent: '{n} continent | {n} continent | {n} continents',
      city: '{n} ville | {n} ville | {n} villes',
      autre: '{n} autre | {n} autre | {n} autres',
    },
  },
}
